
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

interface ChatInputProps {
  input: string;
  isLoading: boolean;
  onInputChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export const ChatInput = ({ input, isLoading, onInputChange, onSubmit }: ChatInputProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      const form = e.currentTarget.form;
      if (form) form.requestSubmit();
    }
  };

  return (
    <form onSubmit={onSubmit} className="flex gap-3">
      <Textarea
        value={input}
        onChange={(e) => onInputChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Ask about handling objections, using tactical empathy..."
        disabled={isLoading}
        className="flex-1 min-h-[60px] max-h-[200px] border-purple-100 focus-visible:ring-purple-500 resize-none"
      />
      <Button 
        type="submit" 
        disabled={isLoading}
        className="bg-purple-600 hover:bg-purple-700 text-white shadow-md hover:shadow-lg transition-all self-end"
      >
        <Send className="h-4 w-4" />
      </Button>
    </form>
  );
};
